// Where LUC sends the user back to after they sign in on the LUC login page.
// LUC only accepts allowed hosts (see "Running locally" in README.md).
const CALLBACK_PATH = '/auth/callback';

export const getLucLoginUrl = () => {
  const { REACT_APP_LUCServerUrl } = process.env;
  const redirectUri = window.location.origin + CALLBACK_PATH;
  return `${REACT_APP_LUCServerUrl}login/#/main?redirect_uri=${encodeURIComponent(
    redirectUri,
  )}`;
};

export const redirectToLucLogin = () => {
  window.location.href = getLucLoginUrl();
};
